// src/components/Footer.js
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaHeart,
  FaCreditCard,
  FaShieldAlt,
  FaClock,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <footer className="footer">
      {/* Vague SVG */}
      <div className="wave-container">
        <svg className="wave" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
            opacity=".25"
            className="shape-fill"
          ></path>
          <path
            d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
            opacity=".5"
            className="shape-fill"
          ></path>
          <path
            d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
            className="shape-fill"
          ></path>
        </svg>
      </div>

      <Container>
        <div className="footer-content">
          <Row>
            {/* Logo et description */}
            <Col lg={4} md={6}>
              <div className="footer-section">
                <div className="d-flex align-items-center mb-3">
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      fontSize: "1.4rem",
                      marginRight: "15px",
                    }}
                  >
                    <img
                      src="/logo.png"
                      alt="Minon Association Logo"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <h4 className="text-white mb-0">Minon Association</h4>
                </div>

                <p className="mb-4">
                  Votre partenaire de confiance pour tous vos services à la
                  personne. Nous simplifions votre quotidien avec
                  professionnalisme et bienveillance.
                </p>

                <div className="d-flex align-items-center mb-2">
                  <FaShieldAlt className="text-warning me-2" />
                  <span>Agréé services à la personne</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <FaCreditCard className="text-warning me-2" />
                  <span>Crédit d'impôt 50%</span>
                </div>
                <div className="d-flex align-items-center">
                  <FaClock className="text-warning me-2" />
                  <span>Disponible 7j/7</span>
                </div>
              </div>
            </Col>

            {/* Liens rapides */}
            <Col lg={2} md={6}>
              <div className="footer-section">
                <h5>Navigation</h5>
                <ul>
                  <li>
                    <a
                      href="#accueil"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("accueil");
                      }}
                    >
                      Accueil
                    </a>
                  </li>
                  <li>
                    <a
                      href="#services"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("services");
                      }}
                    >
                      Services
                    </a>
                  </li>
                  <li>
                    <a
                      href="#apropos"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("apropos");
                      }}
                    >
                      À propos
                    </a>
                  </li>
                  <li>
                    <a href="/emploi">Emploi</a>
                  </li>
                  <li>
                    <a
                      href="#contact"
                      onClick={(e) => {
                        e.preventDefault();
                        scrollToSection("contact");
                      }}
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Services */}
            <Col lg={3} md={6}>
              <div className="footer-section">
                <h5>Nos Services</h5>
                <ul>
                  <li>
                    <a href="#services">Ménage et repassage</a>
                  </li>
                  <li>
                    <a href="#services">Garde d'enfants</a>
                  </li>
                  <li>
                    <a href="#services">Auxiliaires de vie</a>
                  </li>
                  <li>
                    <a href="#services">Entretien de bureaux</a>
                  </li>
                  <li>
                    <a href="#contact">Devis gratuit</a>
                  </li>
                </ul>
              </div>
            </Col>

            {/* Contact */}
            <Col lg={3} md={6}>
              <div className="footer-section">
                <h5>Contact</h5>
                <div className="d-flex align-items-center mb-3">
                  <FaPhone className="me-3" />
                  <div>
                    <a
                      href="tel:0955333007"
                      className="text-decoration-none text-white"
                    >
                      09 55 33 30 07
                    </a>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-3">
                  <FaEnvelope className="me-3" />
                  <div>
                    <a
                      href="mailto:minonassociation@gmail.com "
                      className="text-decoration-none text-white"
                    >
                      minonassociation@gmail.com
                    </a>
                  </div>
                </div>

                <div className="d-flex align-items-start mb-4">
                  <FaMapMarkerAlt className="me-3 mt-1" />
                  <div>
                    <span>Val-de-Marne et Paris</span>
                    <br />
                    <small className="text-light">
                      Alfortville, Choisy-Le-Roi, Créteil, Maisons-Alfort,
                      Paris, Thiais, Villeneuve-Le-Roi
                    </small>
                  </div>
                </div>

                <div className="social-links">
                  <a
                    href="https://facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                  >
                    <FaFacebook />
                  </a>

                  <a
                    href="https://instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                  >
                    <FaInstagram />
                  </a>

                  <a
                    href="https://linkedin.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedin />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="footer-bottom">
          <Row>
            <Col md={6}>
              <p className="mb-0">
                &copy; {currentYear} Minon Association. Tous droits réservés.
              </p>
            </Col>
            <Col md={6} className="text-md-end">
              <p className="mb-0">
                Fait avec <FaHeart className="text-danger mx-1" /> à Paris
              </p>
            </Col>
          </Row>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
